import { BackgroundColor } from '@ampcore/ampcom-contracts'

export const rightRailCardBackgroundColors = [
  BackgroundColor.STONE,
  BackgroundColor.MINT_TINT,
  BackgroundColor.LIME_TINT,
  BackgroundColor.PURPLE_TINT,
  BackgroundColor.BERRY_TINT,
  BackgroundColor.ORANGE_TINT,
  BackgroundColor.WHITE_FACET
] as const

export type RightRailCardBackgroundColor =
  (typeof rightRailCardBackgroundColors)[number]
